// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <detail-view
  :endpoint="endpoint + 'customers'"
  name="Customer"
  parentRoute="customers"
  permissions="customers"
  :values="values"
  :buttons="buttons"
  :refresh="refresh"
  ></detail-view>
</template>
<script>
import moment from 'moment'

import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      refresh: false,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Email',
                value: 'email',
                required: true,
                rule: this.emailRule
              },
              {
                name: 'Contact Name',
                value: 'contactName'
              },
              {
                name: 'Contact Phone',
                value: 'phone'
              }
            ],
            [
              {
                name: 'Address 1',
                value: 'address1'
              },
              {
                name: 'Address 2',
                value: 'address2'
              },
              {
                name: 'City',
                value: 'city'
              },
              {
                name: 'State',
                value: 'state'
              },
              {
                name: 'Postal Code',
                value: 'postalCode'
              }
            ]
          ]
        },
        {
          name: 'Licenses',
          items: [
            [
              {
                name: 'Licenses',
                value: ENDPOINT + 'licenses',
                type: 'itemList',
                id: 'fingerprint',
                pagination: true,
                filter: [{
                  name: 'customer',
                  value: '_id'
                }],
                editRoute: 'licenseEdit',
                headers: [
                  {
                    text: 'Item',
                    value: 'item',
                    context: ENDPOINT + 'items',
                    itemValue: '_id',
                    itemText: 'name'
                  },
                  {
                    text: 'Fingerprint',
                    value: 'fingerprint'
                  },
                  {
                    text: 'Expires',
                    value: 'expires',
                    function: this.formatDate
                  },
                  {
                    text: 'Last Active',
                    value: 'timeAccessed',
                    function: this.formatAccessDate
                  },
                  {
                    text: 'Active',
                    value: 'active',
                    type: 'checkbox'
                  }
                ]
              }
            ]
          ]
        },
        {
          name: 'Logs',
          items: [
            [
              {
                name: 'Logs',
                value: ENDPOINT + 'files',
                type: 'itemList',
                id: 'id',
                pagination: true,
                fileView: 'licenseEdit',
                filter: [{
                  name: 'tags',
                  value: '_id'
                }],
                allowDelete: true,
                editRoute: 'fileEdit',
                permissions: 'files',
                headers: [
                  {
                    text: 'Time Created',
                    value: 'timeCreated',
                    function: this.formatTime
                  },
                  {
                    text: 'Tags',
                    value: 'tags'
                  }
                ]
              }
            ]
          ]
        }
      ]
    }
  },

  computed: {
    buttons: function () {
      var b = []
      if (this.$route.params.id !== 'new') {
        b.push({
          text: 'Refresh',
          function: () => this.refreshButton(),
          color: 'primary'
        })
      }
      return b
    }
  },

  methods: {
    emailRule: function (address) {
      var re = /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z.]{2,}$/
      if (re.test(address)) {
        return true
      } else {
        return 'Not a valid email address'
      }
    },

    formatDate: function (item) {
      var t = moment(item.expires)
      if (t.isBefore('1000-01-01')) {
        return 'N/A'
      }
      return t.format('YYYY-MM-DD')
    },

    formatAccessDate: function (item) {
      var t = moment(item.timeAccessed)
      if (t.isBefore('1000-01-01')) {
        return 'N/A'
      }
      return t.format('YYYY-MM-DD')
    },

    formatTime: function (item) {
      return moment(item.timeCreated).format('YYYY-MM-DD hh:mm:ss A')
    },

    refreshButton: function () {
      this.refresh = !this.refresh
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CustomerEdit.vue